import { HSpacer, IconButton, Text, TopAppBar } from '@/components/DesignSystem';
import { Routes } from '@/constants/Routes';
import { useDashboardNavigate } from '@/pages/CustomerDashboard/helpers';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';

interface EnergyPageFrameProps {
  accessToken: string,
  brandColor: string,
  children: ReactNode,
  testID: string,
  title: string,
}

export const EnergyPageFrame = ({
  accessToken,
  brandColor,
  children,
  testID,
  title,
}: EnergyPageFrameProps) => {
  const navigateToPage = useDashboardNavigate();
  return (
    <Stack
      bgcolor="#F7F7F7"
      data-testid={testID}
      maxWidth="599px"
      minHeight="100vh"
      minWidth="360px"
    >
      <TopAppBar
        isStatic
        leftAccessory={(
          <IconButton
            onClick={() => navigateToPage(Routes.CUSTOMER_DASHBOARD, accessToken)}
            sx={{ color: 'white' }}
            testID="back-button"
          >
            <ArrowBack />
          </IconButton>
        )}
        rightAccessory={<HSpacer size="7" />}
        sx={{ bgcolor: brandColor }}
        testID="top-app-bar"
      >
        <Text category="title-large" sx={{ color: 'white' }}>{title}</Text>
      </TopAppBar>
      {children}
    </Stack>
  );
};
